module.exports = __webpack_public_path__ + "img/ErnestLarkins.16de772e.png";